'use strict';

exports.__esModule = true;

var _slicedToArray2 = require('babel-runtime/helpers/slicedToArray');

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _entries = require('babel-runtime/core-js/object/entries');

var _entries2 = _interopRequireDefault(_entries);

var _assign = require('babel-runtime/core-js/object/assign');

var _assign2 = _interopRequireDefault(_assign);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Environment config variables
 */

// eslint-disable-next-line import/no-mutable-exports
var config = {
  /**
   * @ignore
   * expected configuration for api
   * baseUrl : process.env.API_URL,
   * faustUrl: process.env.FAUST_URL,
   * version : process.env.API_VERSION
   * appName : process.env.API_APP_NAME
   * appPlatform : process.env.API_APP_PLATFORM
   * appVersion : process.env.API_APP_VERSION
   * osrmUrl : process.env.OSRM_URL,
   * GENERATE_MATCH_URL : process.env.GENERATE_MATCH_URL,
   * ESTIMATES_URL : process.env.ESTIMATES_URL
   * gatewayUrl : process.env.GATEWAY_URL
   */
  api: getConfigFromWindow() || getConfigFromProcess() || {},
  models: true,
  timeOffset: 0,
  cacheFetchHeadersEnabled: true, // default is true to honour existing implementation
  fetchTimeout: 300000 // 5 minute default
};

config.update = function (options) {
  config = (0, _assign2.default)(config, options);
};

exports.default = config;


function parseEnvVars(envVars) {
  return envVars && (0, _entries2.default)(envVars).reduce(function (vars, _ref) {
    var _ref2 = (0, _slicedToArray3.default)(_ref, 2),
        key = _ref2[0],
        val = _ref2[1];

    vars[key.replace('REACT_APP_', '')] = val;
    return vars;
  }, {}) || null;
}

function getConfigFromWindow() {
  if (typeof window !== 'undefined') {
    return parseEnvVars(window.env);
  }
  return null;
}

function getConfigFromProcess() {
  if (typeof process.env !== 'undefined') {
    return parseEnvVars(process.env);
  }
  return null;
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/@quiqupltd/quiqupjs/lib/config.js
// module id = 22
// module chunks = 0